import { Box } from '@mui/material';
import { ReactComponent as CircleCheckmark } from '../../../assets/icons/CircleCheckmark.svg';
import { ReactComponent as WarningCheckmark } from '../../../assets/icons/WarningCheckmark.svg';
import { ReactComponent as CircleClose } from '../../../assets/icons/CircleClose.svg';

interface BooleanIndicatorIconProps {
  value: boolean;
  warning?: boolean;
}

const getIcon = (value: boolean, warning: boolean) => {
  if (!value) {
    return <CircleClose />;
  }

  if (warning) {
    return <WarningCheckmark />;
  }

  return <CircleCheckmark />;
};

const BooleanIndicatorIcon = (props: BooleanIndicatorIconProps) => {
  const { value, warning = false } = props;
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {getIcon(value, warning)}
    </Box>
  );
};

BooleanIndicatorIcon.defaultProps = {
  warning: false,
};

export default BooleanIndicatorIcon;
